import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: 2,
      width: '100%',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        rowGap: 1,
      },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 760px)
      //   and (max-device-width: 1180px)`]: {
      //   marginTop: '23px',
      //   marginBottom: '30px',
      // },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 570px)
      //   and (max-device-width: 980px)`]: {
      //   marginTop: '16px',
      //   marginBottom: '23px',
      //   rowGap: 1,
      // },
    },
    section: {
      position: 'relative',
    },
    icon: {
      color: colors.black,
      width: '18px !important',
      height: '18px !important',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '14px !important',
        height: '14px !important',
      },
    },
    iconAndText: {
      display: 'flex',
      alignItems: 'center',
    },
    textContent: {
      position: 'absolute',
      content: '""',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px 0 20px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '0 14px 0 14px',
      },
    },
    text: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '18px',
      color: colors.black,
      paddingLeft: '20px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 12,
        lineHeight: '14px',
        paddingLeft: '15px',
      },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 760px)
      //   and (max-device-width: 1180px)`]: {
      //   fontSize: 16,
      //   lineHeight: '24px',
      // },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 570px)
      //   and (max-device-width: 900px)`]: {
      //   fontSize: 12,
      //   lineHeight: '18px',
      // },
    },
    speed: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '18px',
      color: colors.black,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 12,
        lineHeight: '14px',
      },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 760px)
      //   and (max-device-width: 1180px)`]: {
      //   fontSize: 16,
      //   lineHeight: '24px',
      // },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 570px)
      //   and (max-device-width: 900px)`]: {
      //   fontSize: 12,
      //   lineHeight: '18px',
      // },
    },
  };
};
